import { render, staticRenderFns } from "./orderRiskTrace.vue?vue&type=template&id=158fe5e2&scoped=true"
import script from "./orderRiskTrace.vue?vue&type=script&lang=js"
export * from "./orderRiskTrace.vue?vue&type=script&lang=js"
import style0 from "./orderRiskTrace.vue?vue&type=style&index=0&id=158fe5e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158fe5e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('158fe5e2')) {
      api.createRecord('158fe5e2', component.options)
    } else {
      api.reload('158fe5e2', component.options)
    }
    module.hot.accept("./orderRiskTrace.vue?vue&type=template&id=158fe5e2&scoped=true", function () {
      api.rerender('158fe5e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/risk/orderRiskTrace.vue"
export default component.exports